<template>
  <multipane class="custom-resizer">
    <CategoriesList class="listWrapper"  :style="style"/>
    <multipane-resizer></multipane-resizer>
    <div class="content">
      <transition name="slide" mode="out-in">
        <router-view :key="$route.fullPath"/>
      </transition>
    </div>
  </multipane>
</template>

<script>
import CategoriesList from '@/components/Category/CategoriesList'
import { Multipane, MultipaneResizer } from 'vue-multipane'
import { getListWidthWatch, getListWidthCreated } from '@/helpers/listWidth'

export default {
  data () {
    return {
      style: {
        width: '100%'
      }
    }
  },
  components: {
    CategoriesList,
    Multipane,
    MultipaneResizer
  },
  watch: {
    '$route' (to, from) {
      getListWidthWatch(to, this.style)
    }
  },
  created () {
    getListWidthCreated(this.$route.params, this.style)
  }
}
</script>



// WEBPACK FOOTER //
// src/views/category/Index.vue